// extracted by mini-css-extract-plugin
module.exports = {"container":"QrScanner_container__1TmcC","scanner":"QrScanner_scanner__3et6d","scan":"QrScanner_scan__3-XXV"};